const s = {
  name: "QrCodePayments",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h8v2H2v6H0V0z"/>
		<path class="st0" d="M15,12h-3v3h3V12z"/>
		<path class="st0" d="M19,8H8v11h11V8z M10,17v-7h7v7H10z"/>
		<path class="st0" d="M25,12h3v3h-3V12z"/>
		<path class="st0" d="M32,8H21v11h11V8z M23,17v-7h7v7H23z"/>
		<path class="st0" d="M12,25h3v3h-3V25z"/>
		<path class="st0" d="M8,21h11v11H8V21z M10,23v7h7v-7H10z"/>
		<path class="st0" d="M23,21h-2v2h2v2h-2v5h2v2h2v-2h5v2h2v-2h-2v-5h2v-2h-2v-2h-5v2h-2V21z M27,25v-2h3v2H27z M25,27v-2h2v2H25z
			 M25,27v3h-2v-3H25z"/>
		<path class="st0" d="M32,2h6v6h2V0h-8V2z"/>
		<path class="st0" d="M38,38v-6h2v8h-8v-2H38z"/>
		<path class="st0" d="M2,32v6h6v2H0v-8H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as QrCodePayments
};
